import { last } from 'ramda';
import { WizardContext } from 'react-albus';

const isLastStep = (wizard: WizardContext) => wizard.step.id === last(wizard.steps)?.id;

export { isLastStep };
